<template>
    <v-content class="main-page-wrap text-justify">
        <template v-if="results">
            <div class="results-page">
                <h2 class="display-1 text-xs-center mb-2">Благодарим за участие в исследовании!</h2>
                <div class="text-xs-center mb-4">Вы завершили прохождение всех этапов тестирования.</div>

                <results-literacy v-if="haveLiteracy" :value="results.stage2" :hide-chart="withoutkey"></results-literacy>
                <results-numeracy v-if="haveNumeracy" :value="results.stage3" :hide-chart="withoutkey"></results-numeracy>
                <results-solving v-if="havePs" :value="results.solving" :hide-chart="withoutkey"></results-solving>
                <results-big5 v-if="haveBig5" :value="results.big5" :hide-chart="withoutkey"></results-big5>

                <div class="text-xs-center mt-4">
                    <v-btn color="success" @click="logout">Выйти из системы</v-btn>
                </div>
            </div>
        </template>

        <page-loading v-else></page-loading>
    </v-content>
</template>

<script>
    import {mapState} from 'vuex'
    import PageLoading from '@/components/system/page-loading'
    import ResultsLiteracy from './literacy'
    import ResultsNumeracy from './numeracy'
    import ResultsSolving from './solving'
    import ResultsBig5 from './big5'

    export default {
        components: {
            PageLoading,
            ResultsLiteracy,
            ResultsNumeracy,
            ResultsSolving,
            ResultsBig5
        },
        data () {
            return {}
        },
        computed: {
            ...mapState('results', ['results']),
            ...mapState('testing', ['steps']),
            ...mapState('auth', ['withoutkey']),
            haveLiteracy () {
                return this.steps.indexOf('literacy') > -1
            },
            haveNumeracy () {
                return this.steps.indexOf('numeracy') > -1
            },
            havePs () {
                return this.steps.indexOf('problem-solving') > -1
            },
            haveBig5 () {
                return this.steps.indexOf('big5') > -1
            }
        },
        methods: {
            logout () {
                this.$store.dispatch('auth/logout')
                this.$router.push({name: 'main'})
            }
        },
        mounted () {
            this.$store.dispatch('results/fetch')
        }
    }
</script>

<style lang="stylus">
    .results-page {
        padding 40px 0
    }
</style>
